import type { SubscriptionInvoiceFilterParams, SubscriptionInvoiceRegisterResponse } from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Our own invoice register (MILO-184), admin-only.
 *
 * The customer-facing half of the same model lives on BillingService and is
 * account-scoped; this one deliberately is not — it answers what we billed, to
 * whom, and whether the number series is intact. Kept in its own service so an
 * admin surface never sits on a namespace tenants use.
 */
class SubscriptionInvoiceService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    /**
     * The register, sorted by invoice number so a gap in the series shows up.
     * Not paginated: `meta` carries the totals over the filtered set.
     */
    index(params: SubscriptionInvoiceFilterParams = {}): Promise<AxiosResponse<SubscriptionInvoiceRegisterResponse>> {
        return this.apiService.get('/api/admin/subscription-invoices', { params });
    }

    /** The stored PDF of one invoice, regardless of which account it belongs to. */
    downloadPdf(id: string): Promise<AxiosResponse<Blob>> {
        return this.apiService.get(`/api/admin/subscription-invoices/${id}/pdf`, { responseType: 'blob' });
    }
}

export default SubscriptionInvoiceService;
